// Components
export { AddressInput } from './components/AddressInput'
export { PhoneInput } from './components/PhoneInput'
export { OTPInput } from './components/OTPInput'
export { GenderSelector, GENDER_OPTIONS } from './components/GenderSelector'
export { CountrySelector } from './components/CountrySelector'
export { CitizenshipSelector, useCitizenshipSelector } from './components/CitizenshipSelector'
export { DatePicker } from './components/DatePicker'
export { IBANInput } from './components/IBANInput'
export { MeasurementsInput } from './components/MeasurementsInput'
export { SizeSelector, DEFAULT_SIZES, DEFAULT_SIZE_CHART } from './components/SizeSelector'
export { ParticipationButton } from './components/ParticipationButton'
export { EventInvitationCard } from './components/EventInvitationCard'
export { VideoUpload } from './components/VideoUpload'
export { ShoeSizeInput } from './components/ShoeSizeInput'
export { StatusBadge } from './components/StatusBadge'

// Dialog Components
export {
  Dialog,
  DialogPortal,
  DialogOverlay,
  DialogClose,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
  BaseDialog,
  useDialog,
  useResponsiveDialog
} from './components/Dialog'

export {
  ConfirmDialog,
  DeleteConfirmDialog,
  SaveConfirmDialog,
  DiscardConfirmDialog
} from './components/ConfirmDialog'

export {
  FormDialog,
  CreateDialog,
  EditDialog,
  FormField,
  Input,
  Textarea,
  Label
} from './components/FormDialog'

// File Upload Components
export {
  FileUploadField,
  FileDropZone,
  FileDropZoneContent,
  FileDropZoneCompact,
  FileDropZoneWithPreview,
  FileThumbnail,
  FileThumbnailEnhanced,
  FileThumbnailGrid,
  FileList,
  FileListGrouped,
  DraggableFileList,
  VirtualFileList,
  SearchableFileList,
  FileItem,
  DraggableFileItem,
  UploadProgressBar,
  BatchProgress,
  CancellableProgress,
  ValidationMessages,
  ValidationMessageCompact,
  ValidationSummary,
  InlineValidation,
  useFileUploadUI,
  fileUploadPresets
} from './components/FileUpload'

// Types
export type {
  AddressData,
  PhoneData,
  ValidationResult,
  ValidationRule,
  FieldErrors,
  BaseFieldProps
} from './types'

export type {
  AddressInputProps
} from './components/AddressInput'

export type {
  PhoneInputProps
} from './components/PhoneInput'

export type {
  OTPInputProps
} from './components/OTPInput'

export type {
  GenderSelectorProps,
  GenderOption
} from './components/GenderSelector'

export type {
  CountrySelectorProps,
  Country
} from './components/CountrySelector'

export type {
  CitizenshipSelectorProps
} from './components/CitizenshipSelector'

export type {
  DatePickerProps
} from './components/DatePicker'

export type {
  IBANInputProps,
  IBANMetadata
} from './components/IBANInput'

export type {
  MeasurementsInputProps,
  MeasurementField
} from './components/MeasurementsInput'

export type {
  SizeSelectorProps,
  SizeChart
} from './components/SizeSelector'

export type {
  ParticipationButtonProps
} from './components/ParticipationButton'

export type {
  EventInvitationCardProps,
  EventInvitationData
} from './components/EventInvitationCard'

export type {
  VideoUploadProps,
  VideoUploadData
} from './components/VideoUpload'

export type {
  ShoeSizeInputProps
} from './components/ShoeSizeInput'

export type {
  StatusBadgeProps
} from './components/StatusBadge'

// Dialog Types
export type {
  BaseDialogProps
} from './components/Dialog'

export type {
  ConfirmDialogProps
} from './components/ConfirmDialog'

export type {
  FormDialogProps,
  FormFieldProps
} from './components/FormDialog'

// File Upload Types
export type {
  FileUploadConfig,
  FileUploadFieldProps,
  FileUploadState,
  FileUploadVariant,
  ValidationPosition,
  FileStatus,
  FileUploadEvent,
  FileUploadPresets,
  FileWithUIState,
  UploadProgress,
  UploadResult,
  FileUploadHook,
  BatchUploadHook,
  FileValidationHook,
  FileDropZoneProps,
  FileThumbnailProps,
  FileListProps,
  FileItemProps,
  UploadProgressProps,
  ValidationMessagesProps,
  UseFileUploadUIProps,
  UseFileUploadUIReturn,
  ThumbnailOptions,
  ThumbnailResult
} from './components/FileUpload'

// Validation utilities
export {
  required,
  minLength,
  maxLength,
  email,
  parsePhoneNumber,
  validatePhoneNumber,
  validateAddress
} from './utils/validation'

// Style utilities
export {
  cn,
  baseInputStyles,
  inputVariants,
  labelStyles,
  errorStyles,
  helperTextStyles,
  buttonStyles,
  buttonVariants,
  cardStyles,
  cardHeaderStyles,
  cardContentStyles
} from './utils/styles'

// Country utilities
export {
  COUNTRIES,
  EU_COUNTRIES,
  NORTH_AMERICA_COUNTRIES,
  G7_COUNTRIES,
  getCountryByCode,
  getCountriesByName
} from './utils/countries'